import { format, subDays } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

/**
 * Returns a human-readable group title for a date string in 'yyyy-MM-dd' format.
 * Uses the provided `t` function for localised "Today" and "Yesterday" labels.
 *
 * @param {string} dateString - Date string in 'yyyy-MM-dd' format (site-timezone relative).
 * @param {Function} t - i18next translation function bound to the 'checkIn' namespace.
 * @param {{ todayKey: string, yesterdayKey: string }} keys - Translation keys to use.
 * @param {string} [siteTimezone] - IANA timezone string for the site (e.g. 'Australia/Darwin').
 * @returns {string}
 */
export function getGroupTitle(dateString, t, { todayKey, yesterdayKey }, siteTimezone) {
  const [year, month, day] = dateString.split('-').map(Number)
  const date = new Date(year, month - 1, day)
  const now = new Date()
  const tz = siteTimezone || null
  const todayStr = tz ? formatInTimeZone(now, tz, 'yyyy-MM-dd') : format(now, 'yyyy-MM-dd')
  const yesterdayStr = tz
    ? formatInTimeZone(subDays(now, 1), tz, 'yyyy-MM-dd')
    : format(subDays(now, 1), 'yyyy-MM-dd')
  if (dateString === todayStr) return `${t(todayKey)}, ${format(date, 'MMM d, yyyy')}`
  if (dateString === yesterdayStr) return `${t(yesterdayKey)}, ${format(date, 'MMM d, yyyy')}`
  return format(date, 'EEEE, MMM d, yyyy')
}
